/**
 * Sale effects v2's own rollout (docs/architecture/SALE_EFFECTS.md §3; DISCOUNT_V2_PLAN.md §9.10, decision 5; E3).
 * Ships EMPTY: adding a branch or an account is the rollout, a reviewed code change; removing it is the rollback.
 * Under it, v1's sale listener hands its four promotion effects to v2's (`redux-store/middleware/saleUpdate/
 * saleEffectsV2.ts`). A write that tells its intent (a v2 surface's) goes to v2's effects whatever this says. The
 * matcher is the payment engine's; development and QA use the override.
 */
import { matchesAllowlist, type V2Allowlist } from "@rista/payments/engine/config";

import { devOverride } from "../utils/rolloutOverride";

export const SALE_EFFECTS_V2_ALLOWLIST: V2Allowlist = { branchIds: [], accountUUIDs: [] };

export function saleEffectsV2Enabled(businessData: unknown): boolean {
  return matchesAllowlist(businessData, SALE_EFFECTS_V2_ALLOWLIST) || devOverride("saleEffectsV2Override");
}
